import { apiClient } from '@/api/client';
import type { CatalogCategoryModel } from '@/types/catalog.types';

export const catalogApi = {
  // GET /catalog — categories with labels, colours, tints and methods; any signed-in user.
  list: async (): Promise<CatalogCategoryModel[]> => {
    const { data } = await apiClient.get<CatalogCategoryModel[]>('/catalog');
    return data;
  },
};
